// Modules
require('./news/js/news');
